module.exports = __webpack_public_path__ + "static/img/__1189.3536ac6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__1189.jpg
// module id = CpvD
// module chunks = 0